export const CLUSTER_TABLE_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'DataGrid',
  className: 'grid-pointer-rows',
  disableSelectionOnClick: true,
  pageSize: 10,
  paginationMode: 'client',
  disableColumnMenu: true,
  autoHeight: true,
  initialState: {
    sorting: {
      sortModel: [{ field: 'occurred', sort: 'asc' }],
    },
  },
  onRowClick: {
    op: 'context',
    path: 'onEventSelect',
  },
  columnVisibilityModel: {
    op: 'if',
    condition: {
      op: 'responsive-breakpoint',
      direction: 'down',
      breakpoint: 'sm',
    },
    then: {
      id: false,
      feature: false,
      address: false,
    },
    else: {
      id: false,
    },
  },
  loading: {
    op: 'context',
    path: 'loading',
  },
  columns: {
    op: 'map',
    array: [
      {
        field: 'id',
      },
      {
        field: 'display',
        sortable: false,
        translation: 'common:component.events-table.labels.event-type_one',
        template: {
          op: 'ui',
          name: 'LabelIcon',
          variant: 'body2',
          sx: {
            gap: 1,
          },
          label: {
            op: 'macro:event-label',
            event: {
              op: 'context',
              path: 'event',
            },
            flagEnabled: {
              op: 'if-flag',
              flag: 'portals-translation-retrieval-hook-for-event-and-alert-descriptions-feature',
            },
          },
          subtitle: {
            op: 'if',
            condition: {
              op: 'and',
              values: [
                { op: 'eq', a: { op: 'context', path: 'event.feature' }, b: 'fault/dtc' },
                { op: 'eq', a: { op: 'context', path: 'event.eventTypeId' }, b: 'update' },
                { op: 'ne', a: { op: 'context', path: 'event.data.type' }, b: 'Hino' },
              ],
            },
            then: {
              op: 'ui',
              name: 'FaultSourceDescription',
              eventData: { op: 'context', path: 'event.data' },
              thingId: { op: 'context', path: 'event.thingId' },
              eventId: { op: 'context', path: 'event.eventId' },
            },
            else: {
              op: 'ui',
              name: 'Typography',
              variant: 'caption',
              color: 'text.secondary',
              children: {
                op: 'macro:feature-label',
                feature: { op: 'context', path: 'event.feature' },
              },
            },
          },
          children: {
            op: 'ui',
            name: 'Box',
            sx: {
              lineHeight: 0,
            },
            color: {
              op: 'macro:event-color',
              event: {
                op: 'context',
                path: 'event',
              },
              definitions: {
                op: 'context',
                path: 'notableEvents',
              },
              theme: {
                op: 'theme-property',
              },
            },
            children: {
              op: 'ui',
              name: 'Icon',
              icon: 'CircleIcon',
              sx: { fontSize: '1.5rem' },
            },
          },
        },
        flex: 1,
      },
      {
        field: 'address',
        translation: 'common:component.events.labels.address',
        template: {
          op: 'if',
          condition: {
            op: 'context',
            path: 'event.data.location.address',
          },
          then: {
            op: 'ui',
            name: 'FormatAddress',
            value: {
              op: 'context',
              path: 'event.data.location.address',
            },
          },
          else: {
            op: 'ui',
            name: 'EventAddress',
            location: {
              op: 'context',
              path: 'event.data.location',
            },
          },
        },
        flex: 2,
      },
      {
        field: 'occurred',
        translation: 'common:Occurred',
        template: {
          op: 'format-timestamp',
          value: {
            op: 'context',
            path: 'event.occurred',
          },
        },
        flex: 1,
      },
    ],
    as: 'headers',
    body: {
      field: {
        op: 'context',
        path: 'headers.field',
      },
      flex: {
        op: 'context',
        path: 'headers.flex',
      },
      headerName: {
        op: 'translate',
        translation: {
          op: 'context',
          path: 'headers.translation',
        },
      },
      template: {
        op: 'context',
        path: 'headers.template',
      },
      sortable: false,
    },
  },
  rows: {
    op: 'map',
    array: {
      op: 'context',
      path: 'data',
    },
    as: 'item',
    body: {
      id: {
        op: 'context',
        path: 'item.eventId',
      },
      feature: {
        op: 'macro:feature-label',
        feature: {
          op: 'context',
          path: 'item.feature',
        },
        flagEnabled: {
          op: 'if-flag',
          flag: 'portals-translation-retrieval-hook-for-event-and-alert-descriptions-feature',
        },
      },
      event: {
        op: 'context',
        path: 'item',
      },
      occurred: {
        op: 'context',
        path: 'item.occurred',
      },
      notableEvents: {
        op: 'context',
        path: 'notableEvents',
      },
    },
  },
};
